import {
  VIDEO_FEED_BLOCK,
} from "@/constants/constants";
import {
  createLocalStorageWithExpiration,
  getLocalStorageWithExpiration,
  isMobile,
} from "./helpers/utils";

const storedCount = getLocalStorageWithExpiration(
  VIDEO_FEED_BLOCK.UNIQUE_VIDEO_COUNTS
);
const uniqueCount = storedCount && JSON.parse(storedCount)?.uniqueCount;

export const shouldCallFeedApi = () => {
  return !isMobile() || (uniqueCount < VIDEO_FEED_BLOCK.HARD_BLOCK - 1);
};

export const fetchVideoList = (list: any[]) => {  
  if (!isMobile()) {
    return list;
  }
  
  createLocalStorageWithExpiration(
    VIDEO_FEED_BLOCK.BLOCK_VIDEO_FEED,
    true
  );
  const hasEmptyStr = list.some((item) => item === "");
  const newList = list
    .filter((item) => item !== "")
    .slice(0, VIDEO_FEED_BLOCK.HARD_BLOCK - uniqueCount);

  if (newList.length > 0) {
    const lastItem = newList[newList.length - 1];
    lastItem.hardBlock = true;
  }
  if (hasEmptyStr) {
    newList.push("");
  }
  return newList;
};
